import { useQuery } from '@tanstack/react-query';
import request from '@utils/request';
import { SpaEntityWithTimeslots } from 'shared-types/Spa';
import { getWeeklyTimeslots } from '../utils/getWeeklyTimeslots';
import { SPA_TIMESLOT_AVAILABILITY_TIMEOUT } from './consts';

const getSpaFacilityWithTimeslots = async (
  propertyId: number,
  language: string,
  spaFacilityId: number,
  arrivalDate: string,
  numberOfGuests?: number
) => {
  const { data } = await request.get(`${propertyId}/facilities/${spaFacilityId}/${language}`, {
    params: {
      arrivalDate,
      ...(numberOfGuests !== undefined ? { numberOfGuests } : {}),
    },
    timeout: SPA_TIMESLOT_AVAILABILITY_TIMEOUT,
  });
  return data as SpaEntityWithTimeslots;
};

export function useGetSpaFacilityTimeslots(
  propertyId: number,
  spaFacilityId: number,
  startDate: string,
  language: string,
  enabled = true,
  numberOfDays = 7,
  numberOfGuests = 1
) {
  return useQuery({
    queryKey: getSpaFacilityTimeslotsKey(
      propertyId,
      spaFacilityId,
      startDate,
      language,
      numberOfDays,
      numberOfGuests
    ),
    queryFn: () =>
      getSpaFacilityTimeslots({
        spaFacilityId,
        startDate,
        language,
        propertyId,
        numberOfDays,
        numberOfGuests,
      }),
    enabled,
    staleTime: 0,
    cacheTime: 0,
  });
}

export async function getSpaFacilityTimeslots({
  spaFacilityId,
  startDate,
  language,
  propertyId,
  numberOfDays,
  numberOfGuests,
}: {
  spaFacilityId: number;
  startDate: string;
  language: string;
  propertyId: number;
  numberOfDays?: number;
  numberOfGuests?: number;
}) {
  const getTimeslots = (arrivalDate: string) =>
    getSpaFacilityWithTimeslots(propertyId, language, spaFacilityId, arrivalDate, numberOfGuests);

  return getWeeklyTimeslots(getTimeslots, startDate, numberOfDays);
}

export const getSpaFacilityTimeslotsKey = (
  propertyId: number,
  spaFacilityId: number,
  startDate: string,
  language: string,
  numberOfDays: number,
  numberOfGuests: number
) => [
  'spaFacility',
  'timeslots',
  language,
  propertyId,
  spaFacilityId,
  startDate,
  numberOfDays,
  numberOfGuests,
];
